import React from 'react';
import {Outlet} from 'react-router';
import Navigation from './Navigation';
import VersionMismatchBanner from './ui/VersionMismatchBanner';
import SessionExpiredBanner from './ui/SessionExpiredBanner';

const Layout: React.FC = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <Navigation />
            <div id="content" className="flex-grow-1">
                <VersionMismatchBanner />
                <SessionExpiredBanner />
                <Outlet /> {/* Renders the matched child route component */}
            </div>
            <footer
                className="text-center p-2"
                style={{
                    fontSize: '0.8rem'
                }}
            >
                <a
                    href="https://www.thetaassist.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary"
                >
                    Powered by Theta Assist
                </a>
            </footer>
        </div>
    );
};

export default Layout;
